import React from 'react';
import styled from 'styled-components';
import Select, { components } from 'react-select';
import SelectArrowImg from '../image/SelectArrowImg';
import { isMobileOnly , isIOS} from 'react-device-detect';
import { findIndex } from 'lodash';
import { useState, useEffect } from 'react';
/**
 * DrowDown Select Button
 */
const SelectDropDownBtnBlock = styled.div`
    height: ${props => props.height || '40px'};
    margin-top: ${props => props.marginTop || '0px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-left: ${props => props.marginLeft || '0px'};
    margin-right: ${props => props.marginRight || '0px'};
    position: relative;
`;


const SelectDropDownBtnMobileSelect = styled.select`
    width: 100%;
    font-size: 14px;
    padding: 10px;
    padding-right: 28px;
    background-color: #ffffff;
    height: 100%;
    border: 1px solid #c1c1c1;
    border-radius: 4px;
    color: ${props => props.color || '#333333'};

    appearance:none; /* 기본 스타일 없애기 */
    -webkit-appearance:none;
    -moz-appearance:none;
    -o-appearance:none;

    .select::-ms-expand {display:none;}
    
    &:focus {
        outline: 0;
        border: 1px solid #ffc742;
        border-radius: 4px;
      }

      &:active {
        outline: 0;
        border: 1px solid #ffc742;
        border-radius: 4px;
      }
`;

const SelectArrowImgBtn = styled.div`
    position: absolute;
    right: 4px;
    top: 12px;
`;

const SelectDropDownBtnMobileOption = styled.option`

`;

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <SelectArrowImg />
        </components.DropdownIndicator>
    );
};

const customStyles = {
    option: (provided, state) => {
        //console.log("state : " + JSON.stringify(state));
        return({
            ...provided,
            padding: 10,
            fontSize: 14,
            color: state.isSelected ? (state.value < 0? '#333333':'#ffffff' ): state.isDisabled ?' #cccccc' :'#333333',
            backgroundColor: state.isSelected ? (state.value < 0? '#ffffff':'#ffc742' ): '#ffffff',
        })
    },
    control: (provied, state) => {
        // console.log("provied : " + JSON.stringify(provied));
        const border = state.isFocused ? '1px solid #ffc742' : '1px solid #c1c1c1';
        return {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            fontSize: 14,
            border,
            borderRadius: 4,
            height: '40px'
        };
    },
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        const color= state.data.value*1 < 0? '#808080' : '#111111';
        return { ...provided, opacity, transition, color };
    },
    indicatorSeparator: (provied, state) => {
        // console.log("provied : " + JSON.stringify(provied));
        return {
            ...provied,
            width: 0
        };
    }
}

const SelectDropDownBtn = ({ options, placeholder,
    marginTop, marginBottom, marginLeft, marginRight,
    height, onChange, isDisabled = false, reset = false, handleFocus ,handleBlur}) => {

    const [options2, setOptoins2] = useState([]);
    const [gray, setGray] = useState(true);

    useEffect(() => {
        setOptoins2(options);
        
    }, [options]);

    const onChanegValue = (e) => {
        if(e.target.value*1 === -1) {
            let param = {value: -1};
            onChange(param);
            setGray(true);
        } else {
            let idx = findIndex(options2, (curitem) => {
                return (curitem.value*1 === e.target.value*1);
            })

            if(idx >= 0) {
                onChange(options2[idx]);
                setGray(false);
            }
        }

    }

const onFocus = () => {
    if(handleFocus&&handleFocus!==undefined&&isIOS) {
        handleFocus();
    }
}
const onBlur = () => {
    if(handleBlur&&handleBlur!==undefined&&isIOS) {
        handleBlur();
    }
}
    return (isMobileOnly?
        <SelectDropDownBtnBlock
            height={height}
            marginTop={marginTop}
            marginBottom={marginBottom}
            marginLeft={marginLeft}
            marginRight={marginRight}>
                <SelectDropDownBtnMobileSelect  name="select" id="select" color={gray? '#808080':'#333333'} onChange={onChanegValue} onFocus={onFocus} onBlur={onBlur}>
                    {
                        
                        options.map((option, index) => {
                            return (
                                <SelectDropDownBtnMobileOption key={option.value} value={option.value} disabled={option.disabled === 'yes'}>
                                    {option.label}
                                    </SelectDropDownBtnMobileOption>
                                    );
                        })
                    }
              </SelectDropDownBtnMobileSelect>
              <SelectArrowImgBtn><SelectArrowImg /></SelectArrowImgBtn>
        </SelectDropDownBtnBlock>
        :
        
        <SelectDropDownBtnBlock
            height={height}
            marginTop={marginTop}
            marginBottom={marginBottom}
            marginLeft={marginLeft}
            marginRight={marginRight}>
            {
                reset ? <Select
                    value={null}
                    isDisabled={isDisabled}
                    options={options}
                    placeholder={placeholder}
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    isOptionDisabled={(option) => option.disabled === 'yes'}
                    onChange={onChange} /> :
                    <Select
                        isDisabled={isDisabled}
                        options={options}
                        placeholder={placeholder}
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        isOptionDisabled={(option) => option.disabled === 'yes'}
                        onChange={onChange} />
            }
        </SelectDropDownBtnBlock>
    );
};

export default SelectDropDownBtn;